import { styled, clampFontSize } from "utils";

const Paragraph = styled("p", {
  variants: {
    variant: {
      default: {},
      subtitle: {
        fontWeight: "$normal",
        letterSpacing: "0.003em",
        fontSize: clampFontSize("$5", "$7", 1.5),
        "@bp2": { fontWeight: "$bold" },
      },
    },
  },
  defaultVariants: { variant: "default" },
});

export { Paragraph };
